/**
 * This file is part of the "Awaken Media" project.
 *
 * (c) 2017 - CanalPlus International
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import { connect } from 'react-redux';
import { push } from 'redux-first-history';
import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import getCurrentZone from 'shared/modules/page/selectors/getCurrentZone';
import Complex from '../components/Complex/Complex';
import {
  getProgramsForWeekByZapNumber,
  getCurrentTimestamp
} from '../selectors';
import {
  isTodayIndex,
  getRelativeWidthForTimeRange,
  getWeekDays,
  getDayIndex
} from '../helpers';
import { fetchProgramsForChannelsIfNeeded } from '../actions';
import { HOURS, DAY_START_TIME, PER_PAGE } from '../constants';

const mapStateToProps = (state, { timezone, day, t }) => {
  const selectedDay = getDayIndex(day);
  const days = getWeekDays(selectedDay, t);

  const bigram = getCurrentZone(state);

  const isToday = isTodayIndex(selectedDay);
  const currentTime = dayjs.unix(getCurrentTimestamp(state)).tz(timezone);

  const dayOffset =
    currentTime.hour() >= DAY_START_TIME.hour ? selectedDay : selectedDay - 1;

  const selectedDayFormatted = dayjs().add(dayOffset, 'day').format();

  const dayStartTime = dayjs
    .tz(selectedDayFormatted, timezone)
    .set(DAY_START_TIME);

  const currentTimestamp = currentTime.unix();
  const dayStartTimestamp = dayStartTime.unix();

  let initialSlide = 0;
  let nowPosition = 0;

  const programs = getProgramsForWeekByZapNumber(
    selectedDay,
    dayStartTime,
    timezone
  )(state);

  if (isToday) {
    nowPosition = getRelativeWidthForTimeRange(
      dayStartTimestamp,
      currentTimestamp
    );

    const timeOffsetInHoursFromDayStart = currentTime.diff(
      dayStartTime,
      'hours'
    );

    // Set initialSlide to 0 if programs have not been downloaded yet
    // in order to prevent react-slick to screw render (white screen).
    // this var will be use as a react key for slider component
    // when changing from 0 to x, it will force slider to re-render
    initialSlide = Object.keys(programs).length
      ? timeOffsetInHoursFromDayStart / HOURS.length
      : 0;
  }

  return {
    hours: HOURS,
    perPage: PER_PAGE,
    currentTimestamp,
    dayStartTimestamp,
    days,
    selectedDay,
    programs,
    nowPosition,
    initialSlide,
    isToday,
    bigram
  };
};

const mapDispatchToProps = {
  fetchProgramsForChannelsIfNeeded,
  routerPush: push
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(Complex);
